import { AbstractBaseInputView } from './AbstractBaseInputView';
import { BaseInputProps, NumberInputAttribute } from '../types';
import { isNumber, isUndefined } from '@fxts/core';

/**
 * @see {BaseInputFactory}
 * @example
 * ```ts
 * BaseInputFactory.create('number');
 * BaseInputFactory.create('number', 1);
 * ```
 */
export class NumberInputView extends AbstractBaseInputView<number> {
  protected override attribute: NumberInputAttribute;

  constructor(value?: number, attribute?: NumberInputAttribute, props?: BaseInputProps) {
    super('text', value, attribute, props);
    this.attribute = attribute ?? {};

    // set default
    if (!this.attribute.step) {
      this.attribute.step = 1;
    }
  }

  protected parseValue(value: string | undefined): number | undefined {
    try {
      if (isUndefined(value)) {
        return undefined;
      } else {
        const parsed = Number.parseFloat(value);

        if (!isNumber(parsed) || isNaN(parsed)) {
          return undefined;
        } else {
          const { step } = this.attribute;
          return isUndefined(step) ? parsed : Math.round(parsed / step) * step;
        }
      }
    } catch (_e) {
      return undefined;
    }
  }

  protected override transformValue(): this {
    if (isUndefined(this.value)) {
      return this;
    } else {
      const { min, max, step } = this.attribute;

      if (!isUndefined(min)) {
        this.value = Math.max(this.value, min);
      }
      if (!isUndefined(max)) {
        this.value = Math.min(this.value, max);
      }
      if (!isUndefined(step)) {
        this.value = Math.round(this.value / step) * step;
      }
      return this;
    }
  }

  protected override formatValue(value: number | undefined): string {
    if (isUndefined(value)) {
      return '';
    } else {
      return value.toLocaleString();
    }
  }
}
